import { Options, setup, Vue } from "vue-class-component";
import { useToast } from "primevue/usetoast";
import { useI18n } from "@/shared/composables/use-i18n";
import { currentCompanyModel } from "@/shared/state/current-company.model";

@Options({
    components: {},
})
export class AccountManager extends Vue {
    toast = setup(useToast);
    i18n = setup(useI18n);

    get accountManager() {
        return currentCompanyModel.companyDto.value?.account_manager;
    }
    get initials(): string {
        const a = this.accountManager?.firstname || "";
        const b = this.accountManager?.lastname || "";
        return a + " " + b;
    }
}
